<div fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    <!-- <div style="margin: 20px;">

    </div> -->

    <mat-tab-group style="width: 100%; background: white;padding-bottom: 60px;">
        <mat-tab label="{{'DISPATCH.ENCUESTA_LANZAMIENTO' | translate}}">
            <div fxLayout="column" fxLayoutAlign="center center">
                <h2>{{'DISPATCH.TITULO' | translate}}</h2>
                <mat-card>
                    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="urlMenos50">
                        <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.LINKNORMA35' | translate}} {{'DISPATCH.URL35.MENOS50' | translate}}:</h3> &nbsp;
                        <h3 style="font-weight:bold;"><a href="{{ urlMenos50 }}" target="_blank" *ngIf="urlMenos50">{{urlMenos50}}</a></h3>
                    </div>
                    <!-- <mat-divider></mat-divider> -->

                    <div fxLayout="row" fxLayoutAlign="start center" *ngIf="urlMas50">
                        <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.LINKNORMA35' | translate}} {{'DISPATCH.URL35.MAS50' | translate}}:</h3> &nbsp;
                        <h3 style="font-weight:bold;"><a href="{{ urlMas50 }}" target="_blank" *ngIf="urlMas50">{{urlMas50}}</a></h3>
                    </div>
                    <mat-divider></mat-divider>


                    <div fxLayout="row" fxLayoutAlign="start center">
                        <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.CLAVE_ENCUESTA' | translate}}</h3> &nbsp;
                        <h3 style="font-weight:bold;">{{clave}}</h3>
                    </div>
                    <mat-divider></mat-divider>

                    <div fxLayout="row" fxLayoutAlign="start center">
                        <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.INSTRUCCION3' | translate}}</h3>
                    </div>
                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.INSTRUCCION4' | translate}}</h3>
                    </div>

                    <mat-divider></mat-divider>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.AUTOLOG_35' | translate}}</h3>&nbsp;
                        <h3 style="font-weight:bold;"><a href="{{ urlAutoLogin }}" target="_blank">{{urlAutoLogin}}</a></h3>
                    </div>

                </mat-card>

                <h3 class="h3 secondary-text" style="font-weight:bold; padding-left:20px;">{{'DISPATCH.TEXTO_CONFIRMAR' | translate}}</h3>
                <div *ngIf="!flag" class="p-16" fxLayoutAlign="center center">
                    <div class="h1"> <button mat-raised-button color="accent" (click)="showAlert();" [disabled]="pasoCompleto">{{'DISPATCH.CONFIRMAR_ENVIO' | translate}} </button></div>
                </div>
                <!-- boton -->
                <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                    <div *ngIf="flag" class="p-16" fxLayoutAlign="center center">
                        <div class="h3"><code>{{'DISPATCH.LABEL02' | translate}} </code></div>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="{{'DISPATCH.ENCUESTA_PILOTO_ENVIO' | translate}}">

            <div fxLayout="column" fxLayoutAlign="center center">
                <h2 style="padding-left:20px;">{{'DISPATCH.TITULO_PILOTO' | translate}}</h2>
            </div>
            <div class="p-15" fxLayout="column" fxLayoutAlign="start stretch">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.INSTRUCCION_PILOTO' | translate}}</h3>
                    <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.INSTRUCCION_PILOTO2' | translate}}</h3>
                </div>

                <form class="p-15 example-form" name="form" [formGroup]="form">
                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>Campo requerido</mat-error>
                            <input id="email01" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email01" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>Campo requerido</mat-error>
                            <input id="email02" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email02" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>Campo requerido</mat-error>
                            <input id="email03" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" required formControlName="email03">
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>Campo requerido</mat-error>
                            <input id="email04" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email04" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>Campo requerido</mat-error>
                            <input id="email05" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email05" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">

                        <button mat-raised-button color="accent" (click)="getEmails();" [disabled]="pasoCompleto">{{'DISPATCH.LABEL04' | translate}}</button>

                    </div>



                </form>

            </div>
        </mat-tab>
    </mat-tab-group>


    <!-- <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
        <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                <div class="category" fxFlex>
                    {{'DISPATCH.ENCUESTA_PILOTO' | translate}}
                </div>
            </div> -->
    <!--------- PICK DATE ------->
    <!-- <div class="p-16" fxLayoutAlign="center center">
                <div class="h4 secondary-text">
                    <p><a href="{{ urlMenos50 }}" target="_blank" *ngIf="urlMenos50">{{'DISPATCH.URL35.MENOS50' | translate}} {{urlMenos50}}</a></p>
                    <p><a href="{{ urlMas50 }}" target="_blank" *ngIf="urlMas50">{{'DISPATCH.URL35.MAS50' | translate}} {{urlMas50}}</a></p>

                </div>

            </div>
            <div class="p-16" fxLayoutAlign="center center">
                <div class="h1">{{'DISPATCH.CLAVE' | translate}}</div>
            </div>
            <div class="px-16 pb-4" fxLayoutAlign="center center">
                <div class="pb-8" fxLayout="row" fxLayoutAlign="center center">
                    <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4" style="word-break: break-all;">
                            <mat-label>{{'DISPATCH.ACCESO' | translate}}</mat-label>
                            <input matInput required value="{{clave}}">
                            <mat-icon matSuffix class="secondary-text"></mat-icon>
                        </mat-form-field>
                    </div>
                </div>
            </div>



            <div class="p-16" fxLayoutAlign="center center">
                <div class="h4 secondary-text">{{'DISPATCH.LABEL01' | translate}}</div>
            </div>
            <mat-divider>
            </mat-divider>
            <div class="px-16 pb-4 mt-20" fxLayoutAlign="center center">
                <div class="pb-8" fxLayout="row" fxLayoutAlign="center center">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <div class="h4 secondary-text">
                            {{'DISPATCH.AUTOLOG_35' | translate}}
                        </div><br>
                        <b><a href="{{ urlAutoLogin }}" target="_blank">{{urlAutoLogin}}</a></b>
                    </div>
                </div>
            </div>
            <div *ngIf="!flag" class="p-16" fxLayoutAlign="center center">
                <div class="h1"> <button mat-raised-button color="accent" (click)="showAlert();" [disabled]="emailSend">{{'DISPATCH.CONFIRMAR_ENVIO_35' | translate}} </button></div>
            </div> -->
    <!------- boton  --------->

    <!-- <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                <div *ngIf="flag" class="p-16" fxLayoutAlign="center center">
                    <div class="h3"><code>{{'DISPATCH.LABEL02' | translate}} </code></div>
                </div>
            </div>
        </div>
    </div>

    <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
        <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                <div class="category" fxFlex>
                    {{'DISPATCH.ENCUESTA_PILOTO_ENVIO' | translate}}
                </div>
            </div> -->
    <!--------- PICK DATE ------->
    <!-- <div class="p-15" fxLayout="column" fxLayoutAlign="start stretch">
                <form class="p-15 example-form" name="form" [formGroup]="form">
                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>{{'DISPATCH.LABEL07' | translate}}</mat-error>
                            <input id="email01" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email01" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>{{'DISPATCH.LABEL07' | translate}}</mat-error>
                            <input id="email02" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email02" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>{{'DISPATCH.LABEL07' | translate}}</mat-error>
                            <input id="email03" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" required formControlName="email03">
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>{{'DISPATCH.LABEL07' | translate}}</mat-error>
                            <input id="email04" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email04" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <mat-form-field class="p-5 example-full-width" fxFlex="70">
                            <mat-error>{{'DISPATCH.LABEL07' | translate}}</mat-error>
                            <input id="email05" type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" formControlName="email05" required>
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>
                    </div>

                    <div fxLayout="p-15 row" fxLayoutAlign="center center">
                        <button mat-raised-button color="accent" (click)="getEmails();" [disabled]="pasoCompleto">{{'DISPATCH.LABEL04' | translate}}</button>
                    </div>
                </form> -->

    <!--<div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
                    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'SHEDULE.COMPLETAR_PASO' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
                        <mat-icon>done</mat-icon>
                    </button>
                    <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
                        {{'SHEDULE.PASO_COMPLETADO' | translate}}
                        <mat-icon class="ml-20">done</mat-icon>
                    </button>
                </div>-->
    <!-- </div> -->


    <!------- boton  --------->
    <!-- </div> -->

    <!-- </div> -->

    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'DISPATCH.LABEL08' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
            <mat-icon>done</mat-icon>
          </button>
        <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
            {{'DISPATCH.STEP' | translate}}
            <mat-icon class="ml-20">done</mat-icon>
          </button>
    </div>




</div>